import { ComponentState, useComponentStateMachine } from '../../shared/hooks/useComponentStateMachine'
import { ErrorView } from '../../components/error-view/ErrorView'
import { LoadingView } from '../../components/loading-view/LoadingView'
import { useRepositoriesContext } from '../../../contexts/RepositoriesContext'
import { CustomerCreateFormWrapper } from './wrappers/customer-create-form.wrapper'
import { getAllQuery } from '../logo-editor/logo-editor.screen'
import { useProfileContext } from '../../../contexts/ProfileContext'
import { Role } from '../../../core/models/entities/Role'

export function CustomerCreateScreen() {
  const { role } = useProfileContext()

  switch (role) {
    case Role.Admin: {
      // Admins pick a vendor in step 1, so the vendor list gates first paint.
      //  All other data (logo options, manufacturers) mounts lazily per step.
      return <AdminCustomerCreateScreen />
    }
    case Role.Vendor: {
      return <CustomerCreateFormWrapper vendors={undefined} />
    }
    default: {
      throw new Error("Only Admins and Vendors can create customers")
    }
  }
}

function AdminCustomerCreateScreen() {
  const { state, dataTransition } = useComponentStateMachine()
  const { organizationRepository } = useRepositoriesContext()

  const {
    data: vendors,
    isLoading: isVendorLoading,
    isError: isVendorError,
    isSuccess: isVendorSuccess
  } = organizationRepository.useAllVendors(getAllQuery)

  dataTransition(isVendorLoading, isVendorSuccess, isVendorError)

  return state === ComponentState.Succeed
    ? <CustomerCreateFormWrapper vendors={vendors?.results} />
    : state === ComponentState.Loading
      ? <LoadingView />
      : <ErrorView />
}
